module.exports = "/wwwroot/img/climate_action_page.png?ver=af34f5e4";